<template>
    <div sa-page-layout>
        <b-row>
            <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Paziente</label>
                <span> {{ jsonDataAccettazione.paziente }}</span>
            </b-col>
            <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Data Ingresso</label>
                <date-picker v-model="jsonData.dataIngresso" format="DD-MM-YYYY" value-type="timestamp" type="date" placeholder="Seleziona una data ingresso" :disabled="true"></date-picker>
            </b-col>
        </b-row>
        <b-row
            ><b-col>
                <b-card>
                    <label class="mb-3 text-uppercase">AREA STABILITA' INTERNISTICA:</label>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Situazione attuale:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaStabilitaInternisticaSituazioneAttuale" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaStabilitaInternisticaSituazioneAttuale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Elenco obiettivi:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaStabilitaInternisticaElencoObiettivi" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaStabilitaInternisticaElencoObiettivi }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Metodologie operative:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaStabilitaInternisticaMetodologieOperative" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaStabilitaInternisticaMetodologieOperative }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Operatori:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaStabilitaInternisticaOperatori" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaStabilitaInternisticaOperatori }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-5">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Misure d'esito:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaStabilitaInternisticaMisureEsito" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaStabilitaInternisticaMisureEsito }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Risultato:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaStabilitaInternisticaRisultato" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaStabilitaInternisticaRisultato }}</span>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col></b-row
        >
        <b-row
            ><b-col>
                <b-card>
                    <label class="mb-3 text-uppercase">AREA FUNZIONI VITALI DI BASE:</label>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Situazione attuale:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaFunzioniVitaliBaseSituazioneAttuale" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaFunzioniVitaliBaseSituazioneAttuale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Elenco obiettivi:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaFunzioniVitaliBaseObiettivo" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaFunzioniVitaliBaseObiettivo }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Metodologie operative:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaFunzioniVitaliBaseMetodologieOperative" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaFunzioniVitaliBaseMetodologieOperative }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Operatori:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaFunzioniVitaliBaseOperatori" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaFunzioniVitaliBaseOperatori }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-5">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Misure d'esito:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaFunzioniVitaliBaseMisureEsito" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaFunzioniVitaliBaseMisureEsito }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Risultato:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaFunzioniVitaliBaseRisultato" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaFunzioniVitaliBaseRisultato }}</span>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col></b-row
        >

        <b-row
            ><b-col>
                <b-card>
                    <label class="mb-3 text-uppercase">AREA FUNZIONI SENSO-MOTORIE:</label>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Situazione attuale:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaFunzioniSensoMotorieSituazioneAttuale" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaFunzioniSensoMotorieSituazioneAttuale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Elenco obiettivi:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaFunzioniSensoMotorieElencoObiettivo" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaFunzioniSensoMotorieElencoObiettivo }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Metodologie operative:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaFunzioniSensoMotorieMetodologieOperative" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaFunzioniSensoMotorieMetodologieOperative }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Operatori:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaFunzioniSensoMotorieOperatori" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaFunzioniSensoMotorieOperatori }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-5">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Misure d'esito:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaFunzioniSensoMotorieMisureEsito" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaFunzioniSensoMotorieMisureEsito }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Risultato:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaFunzioniSensoMotorieRisultato" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaFunzioniSensoMotorieRisultato }}</span>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col></b-row
        >

        <b-row
            ><b-col>
                <b-card>
                    <label class="mb-3 text-uppercase">AREA MOBILITA TRASFERIMENTO:</label>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Situazione attuale:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaMobilitaTrasferimentoSituazioneAttuale" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaMobilitaTrasferimentoSituazioneAttuale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Elenco obiettivi:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaMobilitaTrasferimentoElencoObiettivo" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaMobilitaTrasferimentoElencoObiettivo }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Metodologie operative:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaMobilitaTrasferimentoMetodologieOperative" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaMobilitaTrasferimentoMetodologieOperative }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Operatori:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaMobilitaTrasferimentoOperatori" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaMobilitaTrasferimentoOperatori }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-5">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Misure d'esito:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaMobilitaTrasferimentoMisureEsito" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaMobilitaTrasferimentoMisureEsito }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Risultato:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaMobilitaTrasferimentoRisultato" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaMobilitaTrasferimentoRisultato }}</span>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col></b-row
        >

        <b-row
            ><b-col>
                <b-card>
                    <label class="mb-3 text-uppercase">AREA COMPETENZE COGNITIVO-COMPORTAMENTALI:</label>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Situazione attuale:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaComportamentaliSituazioneAttuale" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaComportamentaliSituazioneAttuale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Elenco obiettivi:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaComportamentaliElencoObiettivo" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaComportamentaliElencoObiettivo }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Metodologie operative:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaComportamentaliMetodologieOperative" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaComportamentaliMetodologieOperative }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Operatori:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaComportamentaliOperatori" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaComportamentaliOperatori }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-5">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Misure d'esito:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaComportamentaliMisureEsito" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaComportamentaliMisureEsito }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Risultato:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaComportamentaliRisultato" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaComportamentaliRisultato }}</span>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col></b-row
        >

        <b-row
            ><b-col>
                <b-card>
                    <label class="mb-3 text-uppercase">AREA COMPETENZE COMUNICATIVO-RELAZIONALI:</label>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Situazione attuale:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaComunicativoRelazionaleSituazioneAttuale" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaComunicativoRelazionaleSituazioneAttuale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Elenco obiettivi:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaComunicativoRelazionaleObiettivo" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaComunicativoRelazionaleObiettivo }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Metodologie operative:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaComunicativoRelazionaleMetodologieOperative" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaComunicativoRelazionaleMetodologieOperative }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Operatori:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaComunicativoRelazionaleOperatori" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaComunicativoRelazionaleOperatori }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-5">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Misure d'esito:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaComunicativoRelazionaleMisureEsito" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaComunicativoRelazionaleMisureEsito }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Risultato:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaComunicativoRelazionaleRisultato" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaComunicativoRelazionaleRisultato }}</span>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col></b-row
        >
        <b-row
            ><b-col>
                <b-card>
                    <label class="mb-3 text-uppercase">AREA AUTONOMIA E CURA PERSONE:</label>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Situazione attuale:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaAutonomiaCuraPersonaSituazioneAttuale" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaAutonomiaCuraPersonaSituazioneAttuale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Elenco obiettivi:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaAutonomiaCuraPersonaElencoObiettivo" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaAutonomiaCuraPersonaElencoObiettivo }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Metodologie operative:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaAutonomiaCuraPersonaMetodologieOperatori" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaAutonomiaCuraPersonaMetodologieOperatori }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Operatori:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaAutonomiaCuraPersonaOperatori" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaAutonomiaCuraPersonaOperatori }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-5">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Misure d'esito:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaAutonomiaCuraPersonaMisureEsito" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaAutonomiaCuraPersonaMisureEsito }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Risultato:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaAutonomiaCuraPersonaRisultato" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaAutonomiaCuraPersonaRisultato }}</span>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col></b-row
        >
        <b-row
            ><b-col>
                <b-card>
                    <label class="mb-3 text-uppercase">AREA RIADATTAMENTO E REINSERIMENTO SOCIALE:</label>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Situazione attuale:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaRiadattamentoReinserientoSiuazioneAttuale" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaRiadattamentoReinserientoSiuazioneAttuale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Elenco obiettivi:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaRiadattamentoReinserientoElencoObiettivo" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaRiadattamentoReinserientoElencoObiettivo }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Metodologie operative:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaRiadattamentoReinserientoMetodologieOp" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaRiadattamentoReinserientoMetodologieOp }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Operatori:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaRiadattamentoReinserientoOperatori" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaRiadattamentoReinserientoOperatori }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-5">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Misure d'esito:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaRiadattamentoReinserientoMisureEsito" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaRiadattamentoReinserientoMisureEsito }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Risultato:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaRiadattamentoReinserientoRisultato" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaRiadattamentoReinserientoRisultato }}</span>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col></b-row
        >
        <b-row
            ><b-col>
                <b-card class="mb-5">
                    <label class="mb-3 text-uppercase">AREA EMOTIVO-AFFETTIVA:</label>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Situazione attuale:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaEmotivoAffettivaSituazioneAttuale" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaEmotivoAffettivaSituazioneAttuale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Elenco obiettivi:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaEmotivoAffettivaElencoObiettivi" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaEmotivoAffettivaElencoObiettivi }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Metodologie operative:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaEmotivoAffettivaMetodologieOperative" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaEmotivoAffettivaMetodologieOperative }}</span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Operatori:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaEmotivoAffettivaOperatori" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaEmotivoAffettivaOperatori }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-3">
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Misure d'esito:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaEmotivoAffettivaMisureEsito" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaEmotivoAffettivaMisureEsito }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Risultato:</label>
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.areaEmotivoAffettivaRisultato" :rows="2" :max-rows="6" />
                            <span v-else>{{ jsonData.areaEmotivoAffettivaRisultato }}</span>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col></b-row
        >
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import datePicker from "vue2-datepicker";

export default {
    components: { datePicker },
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },
    data() {
        return {
            jsonData: {
                id: null,
                idAccettazione: null,
                dataIngresso: null,
                areaEmotivoAffettivaElencoObiettivi: null,
                areaEmotivoAffettivaMetodologieOperative: null,
                areaEmotivoAffettivaMisureEsito: null,
                areaEmotivoAffettivaRisultato: null,
                areaEmotivoAffettivaSituazioneAttuale: null,
                areaEmotivoAffettivaOperatori: null,

                areaFunzioniSensoMotorieElencoObiettivo: null,
                areaFunzioniSensoMotorieMetodologieOperative: null,
                areaFunzioniSensoMotorieMisureEsito: null,
                areaFunzioniSensoMotorieRisultato: null,
                areaFunzioniSensoMotorieSituazioneAttuale: null,
                areaFunzioniSensoMotorieOperatori: null,

                areaStabilitaInternisticaElencoObiettivi: null,
                areaStabilitaInternisticaMetodologieOperative: null,
                areaStabilitaInternisticaMisureEsito: null,
                areaStabilitaInternisticaRisultato: null,
                areaStabilitaInternisticaSituazioneAttuale: null,
                areaStabilitaInternisticaOperatori: null,

                areaMobilitaTrasferimentoElencoObiettivo: null,
                areaMobilitaTrasferimentoMetodologieOperative: null,
                areaMobilitaTrasferimentoMisureEsito: null,
                areaMobilitaTrasferimentoRisultato: null,
                areaMobilitaTrasferimentoSituazioneAttuale: null,
                areaMobilitaTrasferimentoOperatori: null,

                areaComportamentaliElencoObiettivo: null,
                areaComportamentaliMetodologieOperative: null,
                areaComportamentaliMisureEsito: null,
                areaComportamentaliRisultato: null,
                areaComportamentaliSituazioneAttuale: null,
                areaComportamentaliOperatori: null,

                areaAutonomiaCuraPersonaElencoObiettivo: null,
                areaAutonomiaCuraPersonaMetodologieOperatori: null,
                areaAutonomiaCuraPersonaMisureEsito: null,
                areaAutonomiaCuraPersonaRisultato: null,
                areaAutonomiaCuraPersonaSituazioneAttuale: null,
                areaAutonomiaCuraPersonaOperatori: null,

                areaRiadattamentoReinserientoElencoObiettivo: null,
                areaRiadattamentoReinserientoMetodologieOp: null,
                areaRiadattamentoReinserientoMisureEsito: null,
                areaRiadattamentoReinserientoRisultato: null,
                areaRiadattamentoReinserientoSiuazioneAttuale: null,
                areaRiadattamentoReinserientoOperatori: null,

                areaFunzioniVitaliBaseObiettivo: null,
                areaFunzioniVitaliBaseMetodologieOperative: null,
                areaFunzioniVitaliBaseMisureEsito: null,
                areaFunzioniVitaliBaseRisultato: null,
                areaFunzioniVitaliBaseSituazioneAttuale: null,
                areaFunzioniVitaliBaseOperatori: null,

                areaComunicativoRelazionaleObiettivo: null,
                areaComunicativoRelazionaleMetodologieOperative: null,
                areaComunicativoRelazionaleMisureEsito: null,
                areaComunicativoRelazionaleRisultato: null,
                areaComunicativoRelazionaleSituazioneAttuale: null,
                areaComunicativoRelazionaleOperatori: null,

                params: "",
                nomeProgetto: "SCHEMA PROGRAMMA QUADRO",
            },

            pathResourceSchemaProgrammaQuadro: "/rsapazienteprischemaprogrammaquadro",
            nomeProgetto: "SCHEMA PROGRAMMA QUADRO",
            params: "",
            pathResourceAccettazione: "/accettazioni",
            jsonDataAccettazione: { paziente: null, dataAccettazione: null },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione ? me.$route.query.idAccettazione : me.$route.params.id;

        let params = { progettoPriSchemaProgrammaQuadro: "si" };
        me.params = JSON.stringify(params);
        me.jsonDataAccettazione = { paziente: null, dataAccettazione: null };
        me.jsonData = {
            idAccettazione: me.idAccettazione,
            id: null,
            dataIngresso: new Date().getTime(),
            areaEmotivoAffettivaElencoObiettivi: null,
            areaEmotivoAffettivaMetodologieOperative: null,
            areaEmotivoAffettivaMisureEsito: null,
            areaEmotivoAffettivaRisultato: null,
            areaEmotivoAffettivaSituazioneAttuale: null,
            areaEmotivoAffettivaOperatori: null,
            areaFunzioniSensoMotorieElencoObiettivo: null,
            areaFunzioniSensoMotorieMetodologieOperative: null,
            areaFunzioniSensoMotorieMisureEsito: null,
            areaFunzioniSensoMotorieRisultato: null,
            areaFunzioniSensoMotorieSituazioneAttuale: null,
            areaFunzioniSensoMotorieOperatori: null,
            areaStabilitaInternisticaElencoObiettivi: null,
            areaStabilitaInternisticaMetodologieOperative: null,
            areaStabilitaInternisticaMisureEsito: null,
            areaStabilitaInternisticaRisultato: null,
            areaStabilitaInternisticaSituazioneAttuale: null,
            areaStabilitaInternisticaOperatori: null,
            areaMobilitaTrasferimentoElencoObiettivo: null,
            areaMobilitaTrasferimentoMetodologieOperative: null,
            areaMobilitaTrasferimentoMisureEsito: null,
            areaMobilitaTrasferimentoRisultato: null,
            areaMobilitaTrasferimentoSituazioneAttuale: null,
            areaMobilitaTrasferimentoOperatori: null,
            areaComportamentaliElencoObiettivo: null,
            areaComportamentaliMetodologieOperative: null,
            areaComportamentaliMisureEsito: null,
            areaComportamentaliRisultato: null,
            areaComportamentaliSituazioneAttuale: null,
            areaComportamentaliOperatori: null,
            areaAutonomiaCuraPersonaElencoObiettivo: null,
            areaAutonomiaCuraPersonaMetodologieOperatori: null,
            areaAutonomiaCuraPersonaMisureEsito: null,
            areaAutonomiaCuraPersonaRisultato: null,
            areaAutonomiaCuraPersonaSituazioneAttuale: null,
            areaAutonomiaCuraPersonaOperatori: null,
            areaRiadattamentoReinserientoElencoObiettivo: null,
            areaRiadattamentoReinserientoMetodologieOp: null,
            areaRiadattamentoReinserientoMisureEsito: null,
            areaRiadattamentoReinserientoRisultato: null,
            areaRiadattamentoReinserientoSiuazioneAttuale: null,
            areaRiadattamentoReinserientoOperatori: null,
            areaFunzioniVitaliBaseObiettivo: null,
            areaFunzioniVitaliBaseMetodologieOperative: null,
            areaFunzioniVitaliBaseMisureEsito: null,
            areaFunzioniVitaliBaseRisultato: null,
            areaFunzioniVitaliBaseSituazioneAttuale: null,
            areaFunzioniVitaliBaseOperatori: null,
            areaComunicativoRelazionaleObiettivo: null,
            areaComunicativoRelazionaleMetodologieOperative: null,
            areaComunicativoRelazionaleMisureEsito: null,
            areaComunicativoRelazionaleRisultato: null,
            areaComunicativoRelazionaleSituazioneAttuale: null,
            areaComunicativoRelazionaleOperatori: null,
            params: me.params,
            nomeProgetto: "SCHEMA PROGRAMMA QUADRO",
        };

        me.loadDataAccettazione();
        if (me.idRisorsa !== null) {
            me.loadData();
        }
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        loadData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchemaProgrammaQuadro + "/" + me.idRisorsa, {}, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonData.nomeProgetto = me.nomeProgetto;
            me.jsonData.params = me.params;
            me.jsonData.idAccettazione = me.idAccettazione;
        },
        loadDataError(error) {
            console.log(error);
        },

        loadDataAccettazione() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceAccettazione + "/" + me.idAccettazione, {}, me.loadAccettazioneSuccess, me.loadAccettazioneError);
        },
        loadAccettazioneSuccess(response) {
            this.jsonDataAccettazione.paziente = response.data.data.accettazioneAnagrafica.nome + " " + response.data.data.accettazioneAnagrafica.cognome;
            this.jsonData.dataIngresso = response.data.data.dataAccettazione;
        },
        loadAccettazioneError(error) {
            console.log(error);
        },
    },
};
</script>
